import { OptionsApi } from '@core/swagger-client';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$webinarId/')({
    loader: async ({ params, context }) => {
        const interest = context.queryClient.ensureQueryData(OptionsApi.interest.getStatus(params.webinarId, { staleTime: 60_000 }));
        const attachments = context.queryClient.ensureQueryData(OptionsApi.webinarAttachments.get(params.webinarId, { staleTime: 60_000 }));
        await Promise.all([interest, attachments]);

        return { webinarId: params.webinarId, interest: await interest, attachments: await attachments };
    }
});
